import type { Parent, ParentOption } from 'bundles/crm/types';

interface Child {
  parentOptionValue?: string;
  parent?: Parent;
  parentId?: number;
  parentType?: string;
}

export function buildParentOption(
  parent: Parent,
  parentType: string,
  label: string,
  labelSuffix?: string
): ParentOption {
  if (labelSuffix) {
    label = `${label} ${labelSuffix}`;
  }

  return {
    label,
    value: getParentOptionValue({ parentId: parent.id, parentType }),
  };
}

export function getParentOptionValue(record: Child) {
  return JSON.stringify({ parentId: record.parentId, parentType: record.parentType });
}

export function parseParentOptionValue(parentOption: ParentOption) {
  return JSON.parse(parentOption.value);
}

export function serializeParentOption(record: Child) {
  if (!record.parentOptionValue) {
    return;
  }

  let parsedParent: { parentId?: string, parentType?: string } = {};
  try {
    parsedParent = JSON.parse(record.parentOptionValue);
  } catch (e) {
    // noop
    return;
  }

  if (parsedParent.parentId) {
    record.parentId = parseInt(parsedParent.parentId);
    record.parentType = parsedParent.parentType;
  }

  delete record.parentOptionValue;
}

export function getParentLabel(record: Child, {
  currentParent,
  parentOptions,
}: {
  currentParent?: Parent | Parent[];
  parentOptions?: ParentOption[];
}) {
  const matchingCurrentParent = findMatchingCurrentParent(record, currentParent);
  if (matchingCurrentParent) {
    return matchingCurrentParent.label || null;
  }

  const option = parentOptions?.find(option => option.value === getParentOptionValue(record));
  return option?.label || record.parent?.label;
}

export function getParentPath(record: Child, { currentParent }: { currentParent?: Parent | Parent[] }) {
  if (findMatchingCurrentParent(record, currentParent)) {
    return null;
  } else {
    return record.parent?.path;
  }
}

function findMatchingCurrentParent(record: Child, currentParents?: Parent | Parent[]) {
  if (!currentParents) {
    return null;
  }

  if (!(currentParents instanceof Array)) {
    currentParents = [currentParents];
  }

  return currentParents.find((parent) => {
    return parent.id === record.parentId && parent.type === record.parentType;
  });
}
